<template>
    <div id="emailTemplateModal" class="modal" role="dialog">
        <div class="modal-dialog modal-lg vertical-align-center">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header bg-teal text-white font-bold">
                    <h4>Templates</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div v-if="modalFlag" class="modal-body bg-white">
                    <div class="flex justify-content-between">
                        <div class="bg-grey-lighter rounded-full w-1/3 flex items-center">
                            <input ref="filter" type="search"
                                   class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-1 rounded-full ml-3 text-sm"
                                   placeholder="Search by name..." @input="debounceFilter" v-model="filter">
                            <div class="flex-1 text-right pr-3">
                                <i v-if="data_loading" class="fa fa-spin fa-spinner text-grey-darkest"
                                   aria-hidden="true"></i>
                            </div>
                        </div>
                        <b-button class="bg-primary float-right" pill variant="info"
                                  @click.stop.prevent="openTemplate()">New Template
                        </b-button>
                    </div>
                    <div class="bg-white shadow-md rounded mb-6 mt-4">
                        <table class="text-left w-full border-collapse">
                            <thead>
                            <tr>
                                <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold':sort.column === 'sequential_team_id'}"
                                    @click="sortBy('sequential_team_id')">
                                    Template Name
                                    <!--                                    <i  class="fa fa-xs ml-2"
                                                                            :class="{'fa-chevron-up' : sort.direction === 'asc',
                                                                        'fa-chevron-down' : sort.direction === 'desc'}"
                                                                            v-if="sort.column === 'template_name'">
                                                                        </i>-->
                                </th>
                                <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold':sort.column === 'name'}"
                                    @click="sortBy('name')">
                                    Last Used
                                    <!--                                    <i  class="fa fa-xs ml-2"
                                                                            :class="{'fa-chevron-up' : sort.direction === 'asc',
                                                                        'fa-chevron-down' : sort.direction === 'desc'}"
                                                                            v-if="sort.column === 'last_used'">
                                                                        </i>-->
                                </th>
                                <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold': sort.column === 'contact'}"
                                    @click="sortBy('contact')">
                                    Last Update
                                    <!--                                    <i  class="fa fa-xs ml-2"
                                                                            :class="{'fa-chevron-up' : sort.direction === 'asc',
                                                                        'fa-chevron-down' : sort.direction === 'desc'}"
                                                                            v-if="sort.column === 'last_modified'">
                                                                        </i>-->
                                </th>
                                <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold': sort.column === 'email'}"
                                    @click="sortBy('email')">
                                    Action
                                </th>
                                <th class="bg-grey-lightest border-b border-grey-light"></th>
                            </tr>
                            </thead>
                            <tbody v-if="emailTemplate.length>0">
                            <tr class="hover:bg-grey-lighter border-b-1"
                                v-for="(template, idx) in emailTemplate" :key="idx">
                                <td class="text-xs pl-2 py-1" style="word-break: break-all">
                                    <div class="cursor-pointer" @click="addTemplateToEmail(template)" tooltip="Select">
                                        {{ template.template_name }}
                                    </div>
                                </td>
                                <td class="text-xs pl-2">
                                    <div>{{ template.last_used }}</div>
                                </td>
                                <td class="text-xs pl-2">
                                    <div>{{ template.last_modified }}</div>
                                </td>
                                <td class="pl-2">
                                    <button type="button"
                                            class="material-icons pr-2 text-md text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer"
                                            @click="addTemplateToEmail(template)">add
                                    </button>
                                    <button type="button"
                                            class="material-icons pr-2 text-md text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer"
                                            @click="editTemplate(template)">edit
                                    </button>
                                    <button type="button"
                                            class="material-icons text-md text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer"
                                            @click="destroyTemplate(template.id)">delete
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr class="border-b-1">
                                <td colspan="4" class="text-center p-4">No template Found</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center">
                        <b-pagination
                            @change="goToPage"
                            v-model="pagination.meta.current_page"
                            :total-rows="pagination.meta.total"
                            :per-page="pagination.meta.per_page"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last">
                        </b-pagination>
                    </div>
                </div>
                <div v-else class="modal-body bg-white">
                    <div class="flex flex-row justify-around">
                        <form class="flex flex-row justify-center w-full">
                            <div class="pb-4 pt-2 rounded shadow-md w-full bg-white">
                                <div
                                    class="text-grey-darkest text-base text mb-8 border-b-2 border-followup-nav pl-4 pb-2"   v-if="emailTemplateObj.id!==null">
                                    Update Template
                                </div>
                                <div
                                    class="text-grey-darkest text-base text mb-8 border-b-2 border-followup-nav pl-4 pb-2"   v-else>
                                    Add Template
                                </div>
                                <div class="flex flex-row justify-content-between px-4">
                                    <div class="mb-3 w-full">
                                        <label class="text-grey-darkest">Template Name</label>
                                        <input v-model="emailTemplateObj.template_name" id="template_name"
                                               title="template_name" maxlength="64"
                                               class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"/>
                                        <span style="color: red" v-if="errorFlag">{{ error.template_name }}</span>
                                    </div>
                                </div>
                                <div class="flex flex-row justify-content-between px-4" v-if="this.isAutomation">
                                    <div class="mb-3 w-full">
                                        <label class="text-grey-darkest">Template Subject</label>
                                        <input v-model="emailTemplateObj.subject" id="subject"
                                               title="subject" maxlength="64"
                                               class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"/>
                                        <span style="color: red" v-if="errorFlag">{{ error.subject }}</span>
                                    </div>
                                </div>
                                <div v-if="allFields.length > 0" class="flex flex-row justify-content-between px-4">
                                    <div class="mb-3 w-full">
                                        <label class="text-grey-darkest w-full">Insert Fields <span v-if="changeOrderKey" class="text-primary float-right pr-1 changeOrderFieldsToolTip cursor-pointer" title="Fields with number are change order fields which will be replaced with the respective number change order data"><i class="fa fa-question-circle-o" aria-hidden="true"></i></span></label>
                                        <multiselect v-if="(automationObject == 'project' || automationObject == 'company' || automationObject == 'contact') && allFields[0].hasOwnProperty('optionTypes')"
                                            id="selectFields"
                                            :options="allFields"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :preserve-search="false"
                                            :taggable="false"
                                            open-direction="below"
                                            placeholder="Select field to add in editor"
                                            :showLabels="false"
                                            label="text"
                                            track-by="id"
                                            :preselect-first="false"
                                            @select="fieldSelected"
                                            group-values="optionValues"
                                            group-label="optionTypes"
                                            :group-select="false"
                                        >
                                        </multiselect>
                                        <multiselect v-else
                                                     id="selectFields"
                                                     :options="allFields"
                                                     :multiple="false"
                                                     :close-on-select="true"
                                                     :clear-on-select="true"
                                                     :preserve-search="false"
                                                     :taggable="false"
                                                     open-direction="below"
                                                     placeholder="Select field to add in editor"
                                                     :showLabels="false"
                                                     label="text"
                                                     track-by="id"
                                                     :preselect-first="false"
                                                     @select="fieldSelected"
                                                     group-values="optionValues"
                                                     group-label="optionTypes"
                                                     :group-select="false"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="flex flex-row justify-content-between px-4">
                                    <div class="mb-3 w-full">
                                        <label class="text-grey-darkest">Template</label>
                                        <ckeditor-template id="comment" v-model="emailTemplateObj.template_text" :user="user"
                                                            mentionFrom="name"></ckeditor-template>
<!--                                        <vue-text-editor :textBinding="emailTemplateObj.template_text" v-on:emailBodyText="emailBodyText"></vue-text-editor>-->
                                        <span style="color: red" v-if="errorFlag">{{ error.template_text }}</span>
                                    </div>
                                </div>
                                <div class="flex flex-row justify-content-between px-4">
                                    <small>
                                       Your signature will be included when you use this template <a href="/settings"> Edit Signature</a>
                                    </small>
                                </div>
                                </br>
                                <div class="flex flex-row justify-content-between px-4"
                                     v-if="emailTemplateObj.id!==null">
                                    <b-button class="bg-primary float-right" pill variant="info"
                                              @click.stop.prevent="addTemplate()">Update
                                    </b-button>
                                </div>
                                <div class="flex flex-row justify-content-between px-4" v-else>
                                    <b-button class="bg-primary float-right" pill variant="info"
                                              @click.stop.prevent="addTemplate()">Create
                                    </b-button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import VueTextEditor from "../shared/vue-text-editor";
// import CKEditor from "../shared/ckeditor-template";
export default {
    name: "email-template-modal-ckeditor",
    components: {VueTextEditor, Multiselect},
    props: ['user', 'allFields', 'isAutomation','changeOrderKey', 'automationObject'],
    data() {
        return {
            errorFlag: false,
            data_loading: true,
            emailTemplateObj: {
                id: null,
                template_name: '',
                subject: '',
                template_text: '',
                template_type: 'project',
            },
            modalFlag: true,
            filter: '',
            emailTemplate: [],
            sort: {
                direction: 'asc',
                column: 'name'
            },
            page: 1,
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            error: {
                template_name: '',
                subject: '',
                template_text: ''
            }
        }
    },
    mounted() {
        this.fetchData();
    },
    watch:{
        emailTemplateObj: {
            immediate: false,
            handler: function (emailObjVal, oldVal) {
                if(emailObjVal.template_name!==""){
                    this.error.template_name='';
                }
            },
            deep: true
        },
        automationObject: {
            immediate: false,
            handler: function (val, oldVal) {
                if(val){
                    this.fetchData();
                }
            },
            deep: true
        },
    },
    methods: {

        fieldSelected(selectedOption, id) {
            let data = [];
            data['button'] = selectedOption.button;
            data['text'] = selectedOption.text;
            data['buttonCode'] = selectedOption.buttonCode;
            Bus.$emit("fieldAddedToEditor", data);
        },
        goToPage(page) {
            this.page = page;
            this.advanced_search ? this.advancedSearch() : this.fetchData();
        },
        open(type) {
            this.emailTemplateObj.id = null;
            this.emailTemplateObj.template_text = '';
            this.emailTemplateObj.template_name = '';
            if (this.isAutomation){
                this.emailTemplateObj.subject = '';
            }
            this.error.template_name='';
            this.error.template_text='';
            this.modalFlag = type;
            $(this.$el).modal('show');
        },
        debounceFilter: _.debounce(function (e) {
            this.filter = e.target.value;
            this.advanced_search = false;
            this.goToPage(1)
        }, 700),
        sortBy(column) {
            this.sort.direction = this.sort.column === column ? (this.sort.direction === 'asc' ? 'desc' : 'asc') : 'asc';
            this.sort.column = column;
            this.goToPage(1);
        },
        fetchData() {
            let params = {
                filter: this.filter,
                column: this.sort.column,
                direction: this.sort.direction,
                page: this.page,
                template_type: 'project',
                automation_template_type: this.automationObject,
            };
            this.data_loading = true;
            axios.get(route(this.getTemplateRoute), {params}).then(({data}) => {
                this.emailTemplate = data.data;
                this.pagination = data;
                this.data_loading = false;
                this.zero_search_results = (this.filter && this.emailTemplate.length === 0);
            });
        },
        openTemplate() {
            this.emailTemplateObj.id = null;
            this.emailTemplateObj.template_text = '';
            this.emailTemplateObj.template_name = '';
            if (this.isAutomation) {
                this.emailTemplateObj.subject = '';
            }
            this.modalFlag = false;
            setTimeout(() => {
                $('.changeOrderFieldsToolTip').tooltip();
                console.log('tooltip');
            }, 1000);
        },
        addTemplate() {
            const templateName = this.emailTemplateObj.template_name;
            let subject = '';
            if (this.isAutomation){
                subject = this.emailTemplateObj.subject;
            }
            const templateText = this.emailTemplateObj.template_text;
            this.emailTemplateObj.automation_template_type = this.automationObject;
            if(!templateName && !templateText){
                this.errorFlag = true;
                this.error.template_name = 'Template name required';
                this.error.template_text = 'Template text required';
                return false;
            }
            if(!subject && this.isAutomation){
                this.errorFlag = true;
                this.error.subject = 'Template subject required';
                return false;
            }
            if (!templateName) {
                this.errorFlag = true;
                this.error.template_name = 'Template name required';
                return false;
            }
            if(!templateText){
                this.errorFlag = true;
                this.error.template_text = 'Template text required';
                return false;
            }
            axios.post(route(this.addTemplateRoute), this.emailTemplateObj).then(({data}) => {
                if (data.success) {
                    this.modalFlag = true;
                    this.emailTemplate = data.data.data;
                    this.pagination.meta = {
                        total: data.data.total,
                        current_page: data.data.current_page,
                        per_page: data.data.per_page
                    };
                    this.data_loading = false;
                    this.filter='';
                    this.zero_search_results = (this.filter && this.emailTemplate.length === 0);
                }
            });
        },
        editTemplate(template) {
            this.emailTemplateObj.id = template.id;
            this.emailTemplateObj.template_text = template.template_text;
            this.emailTemplateObj.template_name = template.template_name;
            if (this.isAutomation){
                this.emailTemplateObj.subject = template.subject;
            }
            this.emailTemplateObj.template_type = template.template_type;
            this.modalFlag = false;

            setTimeout(() => {
                $('.changeOrderFieldsToolTip').tooltip();
                console.log('tooltip');
            }, 1000);
        },
        destroyTemplate(id) {
            axios.post(route(this.deleteTemplateRoute),  {'id': id, 'automation_template_type': this.automationObject }).then(({data}) => {
                    if(data.success){
                        this.emailTemplate = data.data.data;
                        this.pagination.meta = {
                            total:data.data.total,
                            current_page:data.data.current_page,
                            per_page:data.data.per_page
                        };
                        this.data_loading = false;
                        this.zero_search_results = (this.filter && this.emailTemplate.length === 0);
                    }
            });
        },
        addTemplateToEmail(template){
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            Toast.fire({
                type: "success",
                title: "Template has been added."
            });
            this.$emit("addTemplateToEmail", template);
            $(this.$el).modal('hide');
        },
        emailBodyText(val){
            if(val){
                this.error.template_text='';
                this.emailTemplateObj.template_text = val;
            }else{
                this.emailTemplateObj.template_text = '';
            }
        }
    },
    computed: {
        addTemplateRoute() {
            if(this.isAutomation){
                return 'automation.template.store';
            }else{
                return 'api.template.store';
            }
        },
        getTemplateRoute() {
            if(this.isAutomation){
                return 'automation.template.list';
            }else{
                return 'api.template.index';
            }
        },
        deleteTemplateRoute() {
            if(this.isAutomation){
                return 'automation.template.destroy';
            }else{
                return 'api.template.destroy';
            }
        }
    }
}
</script>

<style scoped>
.pagination > li > a {
    color: #4dc0b5;
}

.pagination > li > a:hover {
    background-color: #4dc0b5 !important;
    color: white;
}

.cursor-pointer {
    cursor: pointer;
}

li.page-item.active > a {
    background-color: #4dc0b5 !important;
    border-color: #4dc0b5 !important;
}

a.page-link:focus {
    box-shadow: none;
}
</style>
